import { useState } from 'react'
import { SpotTradeAPI } from '@api/spotTrade';
import { useIsomorphicLayoutEffect } from '@lib/hooks/useIsomorphicLayoutEffect'

export const useCoinDetail = ({ coinCode }) => {
  const [data, setData] = useState({})
  const getDetail = async () => {
    const res = await SpotTradeAPI.getCurrencyDetail({ currency: coinCode })
    setData(res?.obj)
  }
  useIsomorphicLayoutEffect(() => {
    coinCode && getDetail()
  }, [coinCode])
  return data
}
